export function getNewArrWithLastItemReplaced<T>(
  arr: Array<T>,
  newLastItem: T
): Array<T> {
  return [...arr.slice(0, arr.length - 1), newLastItem];
}
